export default function Philosophy() {
  return (
    <section data-testid="philosophy-section" className="py-24 md:py-32 bg-navy-dark relative">
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold/20 to-transparent" />
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold/20 to-transparent" />
      
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-4xl mx-auto text-center space-y-12 animate-on-scroll">
          <p className="text-sm tracking-[0.3em] uppercase text-gold font-body font-medium">
            Our Philosophy
          </p>
          
          <blockquote className="font-heading text-3xl md:text-4xl lg:text-5xl tracking-tight text-white leading-tight italic">
            "Law is not just a profession.{" "}
            <span className="text-gold">It is a responsibility.</span>"
          </blockquote>
          
          <div className="space-y-6 text-left md:text-center max-w-3xl mx-auto">
            <p className="text-base md:text-lg text-gray-400 font-body leading-relaxed">At LexSant, we believe that great legal counsel is not reactive it is strategic. We work alongside our clients, not just for them. Every matter we take on receives the full weight of partner-level attention, clear communication, and relentless advocacy.



            </p>
            <p className="text-base md:text-lg text-gray-400 font-body leading-relaxed">
              We built LexSant to be the firm we would want in our own corner.
            </p>
          </div>

          <div className="grid grid-cols-3 gap-8 pt-8 border-t border-gold/10">
            {[
            { label: "Judgment", desc: "Structured, anticipatory counsel." },
            { label: "Integrity", desc: "Clarity in analysis. Rigor in preparation." },
            { label: "Loyalty", desc: "Long-term stability. Absolute discretion." }].
            map((val, i) =>
            <div key={val.label} className="text-center" data-testid={`philosophy-value-${i}`}>
                <h4 className="font-heading text-lg md:text-xl text-gold tracking-tight mb-1">{val.label}</h4>
                <p className="text-xs md:text-sm text-gray-500 font-body">{val.desc}</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>);

}